<script>
import copyToClipBoard from '@utils/copy-to-clipboard'
import SocialShare from '@components/social-share'

export default {
    components: {
        SocialShare,
    },
    props: {
        mix: {
            type: Object,
            default: () => {},
        },
        hasViewMixOption: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        url() {
            const protocol = `${window.location.protocol}`
            const hostname = `${window.location.hostname}`
            const port = `${window.location.port}`
            const query = this.$route.query.play === 'true' && this.$route.name === 'mix' && String(this.mix.id) === this.$route.params.id ? { play: 'true' } : {}

            return `${protocol}//${hostname}${port ? ':' + port : ''}${
                this.$router.resolve({ name: 'mix', params: { id: this.mix.id }, query }).href
            }`
        },
    },
    methods: {
        copyLinkToClipBoard() {
            copyToClipBoard(this.url)
            this.$store.dispatch('appearance/handleNotification', {
                message: this.$m('LINK_COPIED_CLIPBOARD'),
                type: 'success',
            })
        },
    },
}
</script>

<template>
    <ul class="dropdown-menu">
        <li
            v-if="hasViewMixOption"
            class="dropdown-item"
            @click="$router.push({ name: 'mix', params: { id: mix.id } })"
        >
            <BaseButton
                icon="eye"
                size="medium"
                button-type="transparent"
                @click="() => {}"
            >&nbsp; View Mix</BaseButton>
        </li>
        <div
            v-if="hasViewMixOption"
            class="separator"
        />
        <li class="dropdown-item">
            <BaseFavourites
                v-if="mix"
                :mix="mix"
                size="medium"
                button-type="transparent"
            >
                <span slot="main">Like</span>
                <span slot="alt">Unlike</span>
            </BaseFavourites>
        </li>
        <li class="dropdown-item">
            <BaseFavourites
                v-if="mix.show"
                :show="mix.show"
                size="medium"
                button-type="transparent"
                icon-main="minus"
                icon-alt="plus"
            >
                <span slot="main">Follow Show</span>
                <span slot="alt">Following</span>
            </BaseFavourites>
        </li>
        <li class="dropdown-item">
            <BaseFavourites
                v-if="mix.artist"
                :artist="mix.artist"
                size="medium"
                button-type="transparent"
                icon-main="user-minus"
                icon-alt="user-plus"
            >
                <span slot="main">Follow Artist</span>
                <span slot="alt">Following</span>
            </BaseFavourites>
        </li>
        <h6 class="share-title">Share</h6>
        <div class="separator" />
        <li class="dropdown-item">
            <BaseButton
                icon="facebook"
                size="medium"
                button-type="transparent"
            >
                <SocialShare
                    :url="url"
                    type="facebook"
                />
            </BaseButton>
        </li>
        <li class="dropdown-item">
            <BaseButton
                icon="twitter"
                size="medium"
                button-type="transparent"
            >
                <SocialShare
                    :url="url"
                    :custom-text="`${mix.title} on @friskyradio #feelinfrisky`"
                    type="twitter"
                />
            </BaseButton>
        </li>
        <li
            class="dropdown-item"
            @click="copyLinkToClipBoard"
        >
            <BaseButton
                icon="link"
                size="medium"
                button-type="transparent"
                @click="() => {}"
            >&nbsp;Copy Mix link</BaseButton>
        </li>
    </ul>
</template>

<style lang="scss" scoped>
@import '@design';

.dropdown-menu {
    padding: 0;
    margin: 0;
    list-style: none;
}

.dropdown-item {
    display: flex;
    align-items: center;
    height: 44px;
    padding: 0 $s-m;
}

.separator {
    position: relative;
    display: block;
    width: 100%;
    height: 1px;
    background: $c-mine-shaft;
}

.share-title {
    @extend %contentTitleM;

    margin: $s-s 0 $s-s $s-xl;
}
</style>
